import { ElMessage, ElMessageBox, ElNotification } from 'element-plus'
import {
  sizeFilter,
  handleHttp,
  transformStr3,
  getformListItemsdatas,
  getFileStatus,
  formatToLine } from "@/utils/utils"
import MouseWheelZoom from 'ol/interaction/MouseWheelZoom'
import DoubleClickZoom from 'ol/interaction/DoubleClickZoom'
import PinchZoom from 'ol/interaction/PinchZoom'
import PinchRotate from 'ol/interaction/PinchRotate'
import dragPan from 'ol/interaction/DragPan'

const errorResize = (msg) => {
    let bodywdith = document.body.clientWidth
    bodywdith < 768 ? alert(msg) : ElMessage({message: msg, type: 'warning'})
}

// 获取地址栏参数
function GetQueryString(name){
    var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
    var r = window.location.href.substr(1).match(reg);
    if(r!=null)return  unescape(r[2]); return null;
}

// 判断点击卡片外链链接情况
export function isHasLinkHandle(currentlinkparam, currendata) {
    console.log(currentlinkparam)
    console.log(currendata)
    if (currentlinkparam !== '') {
        let type = currentlinkparam.split(',')
        let linkUrl = parseInt(type[0]) === 1 ? currendata.itemformdata[transformStr3(type[1])] : `/page/${type[1]}/${currendata.id}/form`
        if (linkUrl.toString()) {
            if (linkUrl.includes('http')) {
                window.open(linkUrl)
            } else {
                if (GetQueryString('relationto')){
                    window.open(decodeURIComponent(GetQueryString('relationto')) + linkUrl)
                } else {
                    errorResize('地址无配置门户域名字段')
                }
            }
        } else {
            // errorResize('外链地址为空')
        }
    } else {
        errorResize('未配置外链地址')
    }
}

// 跳转百度点url
export function navigationUrl (val, name) {
    const mapUrl = 'https://api.map.baidu.com/geocoder?location=' + val[0].lat + ',' + val[0].lng + '&output=html&src=webapp.baidu.openAPIdemo'
    const ua = window.navigator.userAgent.toLowerCase()
    const isWechat = ua.match(/MicroMessenger/i) == 'micromessenger'
    // 同步判断小程序，避免 getEnv 异步导致 window.open 丢失用户手势被拦截
    const isMiniProgram = window.__wxjs_environment === 'miniprogram' || ua.indexOf('miniprogram') > -1

    if (isWechat && isMiniProgram && typeof wx !== 'undefined' && wx.miniProgram) {
        wx.miniProgram.redirectTo({
            url: '/pages/position/index?lng=' + val[0].lng + '&lat=' + val[0].lat + '&name=' + name + '&address=' + val[0].address
        })
        return
    }
    window.open(mapUrl, '_blank')
}

export function getlastclickmarker (map, markerId) {
    let markerArr = map.getOverlays()
    console.log(markerArr)
    let reMarker = ''
    for (let i in markerArr) {
      let m = markerArr[i]
      if (m.sid === markerId) {
        reMarker = m
        break
      }
    }
    return reMarker
}
  
// 判断移动端
export function isMobile() {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return flag
}

export function getStr (str) {
    return str.replace(/(<\/?p.*?>)/gi, '')
}

/**
 * 禁止缩放 允许用户通过 滚动鼠标滚轮/双击地图 来缩放地图
 * @param {Object} obj map对象
 * @param {Boolean} flag 填入则允许
 */
export function getPan (obj, flag) {
    // console.log(obj)
    if (flag && flag !== undefined) {
        obj.addInteraction(new MouseWheelZoom({}))
        obj.addInteraction(new DoubleClickZoom({}))
        obj.addInteraction(new PinchZoom({}))
        return false
    }
    obj.getInteractions().getArray().forEach((interaction) => {
        if (interaction instanceof MouseWheelZoom) obj.removeInteraction(interaction)
        if (interaction instanceof DoubleClickZoom) obj.removeInteraction(interaction)
        if (interaction instanceof PinchZoom) obj.removeInteraction(interaction)
    })
}

/**
 * 禁止旋转 允许用户通过在触摸屏上用两根手指扭转来旋转地图
 * @param {Object} obj map对象
 * @param {Boolean} flag 填入则允许
 */
export function getPinchRotate (obj, flag) {
    if (flag && flag !== undefined) {
        obj.addInteraction(new PinchRotate({}))
        return false
    }
    obj.getInteractions().getArray().forEach((interaction) => {
        if (interaction instanceof PinchRotate) obj.removeInteraction(interaction)
    })
}

/**
 * 禁止平移
 * @param {Object} obj map对象
 * @param {Boolean} flag 填入则允许
 */
export function getdragPan (obj, flag) {
    if (flag && flag !== undefined) {
        obj.addInteraction(new dragPan({}))
        return false
    }
    obj.getInteractions().getArray().forEach((interaction) => {
        if (interaction instanceof dragPan) obj.removeInteraction(interaction)
    })
}

/**
 * 解析地图坐标，兼容有无 []、中英文逗号
 * @param {*} val 原始坐标
 * @returns {[number, number]|null} [lng, lat] 或 null
 */
export function parseMapCoordinates (val) {
    if (val === undefined || val === null || val === '') return null
    if (Array.isArray(val) && val.length >= 2) {
        const lng = Number(val[0])
        const lat = Number(val[1])
        if (Number.isFinite(lng) && Number.isFinite(lat)) return [lng, lat]
        return null
    }
    let str = String(val).trim()
    if (!str) return null
    if (str.startsWith('[') && str.endsWith(']')) {
        try {
            const parsed = JSON.parse(str.replace(/，/g, ','))
            if (Array.isArray(parsed) && parsed.length >= 2) {
                const lng = Number(parsed[0])
                const lat = Number(parsed[1])
                if (Number.isFinite(lng) && Number.isFinite(lat)) return [lng, lat]
            }
        } catch (e) { /* fall through to split */ }
        str = str.slice(1, -1).trim()
    }
    str = str.replace(/，/g, ',').trim()
    const parts = str.split(',').map(item => item.trim()).filter(Boolean)
    if (parts.length < 2) return null
    const lng = Number(parts[0])
    const lat = Number(parts[1])
    if (!Number.isFinite(lng) || !Number.isFinite(lat)) return null
    return [lng, lat]
}

/**
 * 规范化地图坐标为英文逗号字符串 lng,lat
 * @param {*} val 原始坐标
 * @returns {string}
 */
export function normalizeMapCoordinates (val) {
    const coords = parseMapCoordinates(val)
    if (!coords) return ''
    return `${coords[0]},${coords[1]}`
}

/**
 * 解析点位样式字段。内容必须是 JSON；富文本等非法内容返回空字符串，避免整批点位解析中断。
 * @param {*} val 原始 seniorset
 * @returns {Object|string}
 */
export function parseSeniorset (val) {
    if (val === undefined || val === null || val === '') return ''
    const stripped = String(val).replace(/(<\/?p.*?>)/gi, '').trim()
    if (!stripped || (stripped[0] !== '{' && stripped[0] !== '[')) return ''
    try {
        const parsed = JSON.parse(stripped)
        if (parsed && typeof parsed === 'object') return { ...parsed }
    } catch (e) { /* 非 JSON，回退全局样式 */ }
    return ''
}

